import Header from './header';
import './header.scss';

export default Header;